import { TFunction } from 'i18next';

export const getStatusOptions = (t: TFunction) => ({
  AC: t('requestStatusName.AC'),
  CA: t('requestStatusName.CA'),
  CL: t('requestStatusName.CL'),
  IP: t('requestStatusName.IP'),
  NR: t('requestStatusName.NR'),
  OH: t('requestStatusName.OH')
});

export const getCancellationReasonOptions = (t: TFunction) => ({
  A: t('consignment.cancellationReason.accident', 'Accident'),
  L: t('consignment.cancellationReason.lateDelivery', 'Late Delivery'),
  S: t('consignment.cancellationReason.securityIssue', 'Security Issue'),
  E: t('consignment.cancellationReason.error', 'Error'),
  O: t('consignment.cancellationReason.other', 'Other')
});
